import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadClub,
  saveClub,
  clearAjaxCall,
  uploadSignature,
  uploadSignatureStarted
} from '../actions/Club'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import ClubDetails from './Club/ClubDetails'
import EditClub from './Club/EditClub'

import { grantAdmin } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  course: {}
}

class Club extends Component {
  constructor() {
    super()
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this._handleImageChange = this._handleImageChange.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  _handleImageChange(e) {
    e.preventDefault()
    let reader = new window.FileReader()
    if (e.target.files.length > 0) {
      let file = e.target.files[0]
      this.props.uploadSignatureStarted()
      reader.onloadend = () => {
        this.props.uploadSignature({ image: reader.result })
      }
      reader.readAsDataURL(file)
    }
  }
  componentWillMount() {
    if (this.props.club.info === null) {
      this.props.loadClub()
    }
  }
  showEdit() {
    this.setState({ showEdit: true })
  }
  hideModal() {
    this.setState(initialState)
  }
  reloadClub() {
    this.props.loadClub()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.club.ajaxSpinner &&
      !this.props.club.ajaxSpinner &&
      this.props.club.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.club.ajaxSpinner &&
      !this.props.club.ajaxSpinner &&
      this.props.club.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { info, error, loading, ajaxSpinner } = this.props.club
    const { list } = this.props.fiscalyear
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Associazione</div>
          <div className='ph-descr txt'>
            Per la generazione delle ricevute e la contabilità è indispensabile
            inserire i dati di inizio e fine anno fiscale
            <br />
            L'anno fiscale viene generato automaticamente dal sistema, non serve
            cambiarlo tutti gli anni.
          </div>
          <ul className='ph-btn'>
            {grantAdmin() && (
              <li>
                <form onSubmit={this._handleSubmit} className='hidden'>
                  <label htmlFor='upload_avatar'>
                    <input
                      type='file'
                      ref={(ref) => (this.upload = ref)}
                      id='upload_avatar'
                      className='upld'
                      onChange={this._handleImageChange}
                    />
                  </label>
                </form>
                <button
                  onClick={(e) => this.upload.click()}
                  className='lnk-tools'
                >
                  <i className='fas fa-signature'></i> carica firma
                </button>
              </li>
            )}
            {grantAdmin() && (
              <li>
                <button onClick={() => this.showEdit()} className='lnk-tools'>
                  <i className='fas fa-edit'></i> modifica
                </button>
              </li>
            )}
            <li>
              <button onClick={() => this.reloadClub()} className='lnk-tools'>
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {info !== null && (
          <ClubDetails
            info={info}
            fiscalyear={list}
            showDelete={this.showDelete}
            showEdit={this.showEdit}
          />
        )}
        {this.state.showEdit && (
          <EditClub info={info} hideModal={this.hideModal} />
        )}
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadClub,
  saveClub,
  clearAjaxCall,
  uploadSignature,
  uploadSignatureStarted
})(Club)



// WEBPACK FOOTER //
// ./src/components/Club.js